import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IOrderRepository } from '@/coreInfrastructureModule/interfaces/IOrderRepository';
import { UpdateOrderMemoAdapter } from '../adapters/updateOrderMemoAdapter';

/**
 *　発注メモの更新を行うユースケース
 */
export class UpdateOrderMemoUseCase {
  private repository: IOrderRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IOrderRepository) {
    this.repository = repository;
  }

  /**
   * 発注メモを更新する
   * @param orderId - 発注ID
   * @param memo - メモの内容
   */
  public async Execute(orderId: string, memo: string): Promise<INetworkResult<undefined, IError>> {
    try {
      const request = UpdateOrderMemoAdapter.adapt(memo);
      const response = await this.repository.updateOrderMemo(orderId, request);
      switch (response.status.type) {
        case 'success':
          break;
        case 'error':
          return {
            status: {
              type: 'error',
              error: response.status.error,
            },
          };
        default:
          throw new Error('Invalid status');
      }

      return {
        status: {
          type: 'success',
          data: undefined,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: 'An unexpected error occurred',
          },
        },
      };
    }
  }
}
